import { MenuItem } from "@mui/material";
import dayjs from "dayjs";

export const createMenuItems = (
  items,
  noOptionsMessage = "Nessuna opzione disponibile"
) => {
  if (!items || items.length === 0) {
    return <MenuItem value="">{noOptionsMessage}</MenuItem>;
  }

  return [
    <MenuItem key="placeholder" value="" disabled>
      Seleziona un'opzione
    </MenuItem>,
    ...items.map((item) => (
      <MenuItem key={item.id} value={item.id}>
        {item.name}
      </MenuItem>
    )),
  ];
};

export const formatDateForForm = (date) => {
  return date ? dayjs(date).format("YYYY-MM-DD") : null;
};

export const FORM_CONSTANTS = {
  DEFAULT_SUB_AREAS: true,
  RADIO_VALUES: {
    TRUE: "true",
    FALSE: "false",
  },
  MESSAGES: {
    NO_OPTIONS: "Nessuna opzione disponibile",
    START_DATE_REQUIRED:
      "Data di inizio obbligatoria quando è selezionata una coltura",
    END_DATE_REQUIRED:
      "Data di fine obbligatoria quando è selezionata una coltura",
    END_DATE_AFTER_START:
      "La data di fine deve essere successiva alla data di inizio",
    NO_SUB_AREAS:
      "Selezionando No, tutti i sottoterreni associati a questo terreno verranno eliminati definitivamente.",
  },
  TITLES: {
    CREATE: "Info generali",
    EDIT: "Modifica terreno",
  },
  DESCRIPTIONS: {
    CREATE:
      "Inizia a creare il tuo terreno indicando il nome con il quale vuoi visualizzarlo e la prossima o attuale coltura",
    EDIT: "Modifica le informazioni del tuo terreno",
  },
};
